function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.667 9C.667 4.4 4.4.667 9 .667S17.333 4.4 17.333 9 13.6 17.333 9 17.333A8.336 8.336 0 01.667 9zm9.166-.833v5H8.167v-5h1.666zM9 15.667A6.676 6.676 0 012.333 9 6.676 6.676 0 019 2.333 6.675 6.675 0 0115.667 9 6.676 6.676 0 019 15.667zm.833-10.834V6.5H8.167V4.833h1.666z",
  fill: "#005646"
});

function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgInfoOutline;